import { render, staticRenderFns } from "./CustomerGatewayForm.vue?vue&type=template&id=528a6ae6&"
import script from "./CustomerGatewayForm.vue?vue&type=script&lang=js&"
export * from "./CustomerGatewayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports